<template>
  <div class="active">
    <base-card
      :listTitle="this.listTitle"
      :listContent="this.listContent"
      :listUrl="this.listUrl"
      :total="this.total"
      @currentPageChange="handlePageChange"
    ></base-card>
    <base-box :key="this.reRenderKey" :article="this.article"></base-box>
  </div>
</template>

<script>
import BaseCard from "../components/BaseCard.vue";
import BaseBox from "../components/BaseBox.vue";
import getPath from "../utils/getPath";
import getArticleList from "../utils/getArticleList";
import getArticleCount from "../utils/getArticleCount";

export default {
  components: {
    BaseCard,
    BaseBox
  },
  data() {
    return {
      article: {},
      listTitle: "",
      listContent: {},
      listUrl: "",
      total: 0,
      isRender: false,
      reRenderKey: 0
    };
  },
  watch: {
    $route: {
      handler(newVal, oldVal) {
        getPath(this.$http, newVal, "/dingyang_new/show-edit-article/").then(
          res => {
            if (res.data.data) {
              this.article.title = res.data.data[0].title;
              this.article.content = res.data.data[0].content;
              this.forceRerender();
            }
          }
        );
      },
      deep: true,
      immediate: true
    }
  },
  async created() {
    getArticleCount(this.$http, "dingyang_new/get-articles-count").then(res => {
      this.total = res.data.data[0]["COUNT(*)"];
    });
    getArticleList(
      this.$http,
      "/dingyang_new/get-articles",
      "",
      "",
      "1",
      "8"
    ).then(articleList => {
      this.listContent = articleList.data.data;
      this.listTitle = "新闻中心";
      this.listUrl = "/#/active/";
    });
  },
  methods: {
    forceRerender() {
      this.reRenderKey += 1;
    },
    async handlePageChange(val) {
      getArticleList(
        this.$http,
        "/dingyang_new/get-articles",
        "",
        "",
        val,
        "8"
      ).then(articleList => {
        this.listContent = articleList.data.data;
        this.listTitle = "新闻中心";
        this.listUrl = "/#/active/";
      });
    }
  }
};
</script>

<style scoped>
.active {
  background-color: #f5f5f5;
}
</style>



// WEBPACK FOOTER //
// src/pages/active.vue